import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { useMemo } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";

export function useColorHelper(initialColor: string = "") {
  const {
    color,
    doorOptions,
    doorOptionsLoadError,
    doorOptionsLoading,
    updateColor,
    updateColoredGlass,
    resetVerfsetExtraOptions,
    getConfigurationProduct,
    isOpdekOrStomp,
  } = useConfigurationOptionsContext();
  const { onConfig } = useAnalytics();

  const colorsContainer = doorOptions?.color || [];

  const selectedColor = useMemo(() => {
    // Assuming 'colorData' and 'selectedColorCode' are available in the scope
    if (color?.code === null || !doorOptions?.color) return;

    // Use flatMap to flatten the colors arrays from all categories into a single array
    // const allColors = colorData.flatMap((category) => category.colors);

    // Find the selected color by searching the flattened array
    const selectedColor = doorOptions?.color.find(
      (item) => color?.code === item.code,
    );

    return selectedColor;
  }, [color?.code, doorOptions?.color]);

  const onColorClick = (color: OptionTemplate) => {
    updateColor(color);
    updateColoredGlass(color);

    const product = getConfigurationProduct();
    if (product)
      onConfig({
        ...product,
        doorColor: {
          id: color.id,
          name: color.name,
          code: color.code,
          description: color.description,
          imageId: color.imageId,
          price: color.price,
        },
      });

    // Reset verfset extra option only if door has a kozijn: StompeDeur, OpdekDeur
    if (isOpdekOrStomp) {
      resetVerfsetExtraOptions();
    }
  };

  return {
    doorOptionsLoading,
    doorOptionsLoadError,
    colorsContainer,
    selectedColor,
    onColorClick,
  };
}
